var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from 'react';
import { Card } from "./..";
import { useToggle } from "../../hooks/useToggle";
import { ExpandableCardHeader, ExpandableCardHeaderWithActions } from './components';
var ControlledCard = function (_a) {
    var defaultIsExpanded = _a.defaultIsExpanded, trigger = _a.trigger, onToggle = _a.onToggle, props = __rest(_a, ["defaultIsExpanded", "trigger", "onToggle"]);
    var _b = __read(useToggle(defaultIsExpanded), 2), isExpanded = _b[0], toggle = _b[1];
    // for notify purposes only
    useEffect(function () {
        if (typeof onToggle === 'function') {
            onToggle(isExpanded);
        }
    }, [isExpanded, onToggle]);
    return (React.createElement(UncontrolledCard, __assign({ trigger: trigger, isExpanded: isExpanded, onToggle: toggle }, props)));
};
var UncontrolledCard = function (_a) {
    var _b = _a.isExpanded, isExpanded = _b === void 0 ? true : _b, title = _a.title, actions = _a.actions, trigger = _a.trigger, onToggle = _a.onToggle, titleLss = _a.titleLss, headerLss = _a.headerLss, triggerPosition = _a.triggerPosition, triggerColor = _a.triggerColor, props = __rest(_a, ["isExpanded", "title", "actions", "trigger", "onToggle", "titleLss", "headerLss", "triggerPosition", "triggerColor"]);
    var panel = props.children &&
        React.Children.map(props.children, function (child) {
            return React.isValidElement(child)
                ? React.cloneElement(child, { isExpanded: isExpanded })
                : child;
        });
    return (React.createElement(Card, __assign({}, props, { lss: __assign({ border: 'regular' }, props.lss) }),
        actions ? (
        // This header wraps the title/trigger in a transparent button for a11y purposes; the trigger will always be to the left of the title.
        React.createElement(ExpandableCardHeaderWithActions, { actions: actions, title: title, onClick: function (e) {
                e.preventDefault();
                if (typeof onToggle === 'function') {
                    onToggle();
                }
            }, trigger: trigger, isExpanded: isExpanded, isExpandable: true, triggerColor: triggerColor, lss: headerLss, titleLss: titleLss })) : (
        // This entire header is wrapped in a transparent button
        React.createElement(ExpandableCardHeader, { title: title, onClick: function (e) {
                e.preventDefault();
                if (typeof onToggle === 'function') {
                    onToggle();
                }
            }, trigger: trigger, isExpanded: isExpanded, isExpandable: true, triggerPosition: triggerPosition, triggerColor: triggerColor, lss: headerLss, titleLss: titleLss })),
        isExpanded && React.createElement(React.Fragment, null, panel)));
};
/**
 * This component will be "uncontrolled" if an `isExpanded` prop is passed in. Otherwise, it will operate as "controlled."
 */
export var ExpandableCard = function (_a) {
    var props = __rest(_a, []);
    return typeof props.isExpanded === 'boolean' ? (React.createElement(UncontrolledCard, __assign({}, props))) : (React.createElement(ControlledCard, __assign({}, props)));
};
//# sourceMappingURL=ExpandableCard.js.map